import React, { useState, useEffect, useRef } from 'react';
import './CreateQuizModal.scss';

const CreateQuizModal = ({ onClose, onGenerate }) => {
  const dropdownRef = useRef(null);
  const [activeDropdown, setActiveDropdown] = useState(null);
  
  const [formData, setFormData] = useState({
    sections: ['QUANT', 'VARC'],
    // Composition ab section-wise independent hai
    composition: {
      QUANT: { MCQ: 0, TITA: 0, SHORT: 0 },
      VARC: { MCQ: 0, TITA: 0, SHORT: 0 },
      LR: { MCQ: 0, TITA: 0, SHORT: 0 },
      DI: { MCQ: 0, TITA: 0, SHORT: 0 }
    },
    date: '',
    hour: '12',
    minute: '00',
    period: 'AM',
    duration: ''
  });

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setActiveDropdown(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const toggleSelection = (field, opt) => {
    setFormData(prev => ({
      ...prev,
      [field]: prev[field].includes(opt) 
        ? prev[field].filter(item => item !== opt) 
        : [...prev[field], opt]
    }));
  };

  // Har section ke liye independent count update
  const updateComp = (section, type, val) => {
    setFormData(prev => ({
      ...prev,
      composition: {
        ...prev.composition,
        [section]: {
          ...prev.composition[section],
          [type]: Math.max(0, prev.composition[section][type] + val)
        }
      }
    }));
  };

  return (
    <div className="modal-overlay">
      <div className="create-quiz-modal" ref={dropdownRef}>
        <div className="modal-header">
          <h2>Create New Quiz</h2>
          <button className="close-x" onClick={onClose}>&times;</button>
        </div>

        <div className="modal-body">
          {/* Step 1: Only Section Selection (As per Image) */}
          <div className="form-section">
            <span className="step-tag">1. SUBJECT & SECTION SELECTION</span>
            <div className="input-grid single-col">
              <div className="field-group">
                <label>Select Sections (Based on selection, composition will appear below)</label>
                <div className="custom-select" onClick={() => setActiveDropdown(activeDropdown === 'sec' ? null : 'sec')}>
                  <div className="select-trigger">
                    {formData.sections.join(', ') || 'Select Sections'}
                    <span className={`arrow ${activeDropdown === 'sec' ? 'up' : ''}`}>▼</span>
                  </div>
                  {activeDropdown === 'sec' && (
                    <div className="dropdown-list">
                      {['QUANT', 'VARC', 'LR', 'DI'].map(opt => (
                        <div 
                          key={opt} 
                          className={`list-item ${formData.sections.includes(opt) ? 'selected' : ''}`} 
                          onClick={(e) => { e.stopPropagation(); toggleSelection('sections', opt); }}
                        >
                          <div className="checkbox-box"></div>
                          {opt}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Step 2: Segregated Composition (Independent per Section) */}
          <div className="form-section">
            <span className="step-tag">2. SECTION-WISE COMPOSITION</span>
            <div className="segregation-container">
              {formData.sections.length > 0 ? (
                formData.sections.map(sec => (
                  <div className="section-config-card" key={sec}>
                    <div className="section-label-header">
                      <h4>{sec} Section</h4>
                      <span className="total-q-badge">
                        Total: {Object.values(formData.composition[sec]).reduce((a, b) => a + b, 0)}
                      </span>
                    </div>
                    <div className="comp-grid">
                      {['MCQ', 'TITA', 'SHORT'].map(type => (
                        <div className="comp-card mini" key={type}>
                          <label>{type}</label>
                          <div className="counter-row">
                            <button onClick={() => updateComp(sec, type, -1)}>&minus;</button>
                            <span>{formData.composition[sec][type]}</span>
                            <button onClick={() => updateComp(sec, type, 1)}>+</button>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                ))
              ) : (
                <p className="placeholder-text">Please select a section above to start composition.</p>
              )}
            </div>
          </div>

          {/* Step 3: Scheduling */}
          <div className="form-section">
            <span className="step-tag">3. SCHEDULING</span>
            <div className="schedule-row">
              <div className="field-group">
                <label>Date</label>
                <input type="date" value={formData.date} onChange={(e) => setFormData({...formData, date: e.target.value})} />
              </div>
              <div className="field-group">
                <label>Start Time</label>
                <div className="time-picker-row">
                  <select value={formData.hour} onChange={(e) => setFormData({...formData, hour: e.target.value})}>
                    {['12','01','02','03','04','05','06','07','08','09','10','11'].map(h => <option key={h}>{h}</option>)}
                  </select>
                  <select value={formData.minute} onChange={(e) => setFormData({...formData, minute: e.target.value})}>
                    {['00','15','30','45'].map(m => <option key={m}>{m}</option>)}
                  </select>
                  <select className="period-select" value={formData.period} onChange={(e) => setFormData({...formData, period: e.target.value})}>
                    <option>AM</option><option>PM</option>
                  </select>
                </div>
              </div>
              <div className="field-group">
                <label>Duration (min)</label>
                <input type="number" placeholder="Min" value={formData.duration} onChange={(e) => setFormData({...formData, duration: e.target.value})} />
              </div>
            </div>
          </div>
        </div>

        <div className="modal-footer">
          <button 
            className="btn-generate" 
            onClick={(e) => onGenerate(formData)}
            disabled={formData.sections.length === 0}
          >
            Generate Test
          </button>
        </div>
      </div>
    </div>
  );
};

export default CreateQuizModal;